var SparkDigital = SparkDigital || {};

SparkDigital = (function () {

    /***********************************************************
    // GLOBAL - FOR STORING REUSABLE VARIABLES (EG. DOM)
    ***********************************************************/
    var global = {

        ajax_endpoints: window["ajax_endpoints"],

        google_recaptcha: window["google_recaptcha_site_key"],

        wp_nonce: window["wp_nonce"],

        breakpoint: {}, // bootstrap viewport

        assets_dir: window["assets_dir"],

        debug_mode: $('body').hasClass('debug-mode'), // Debug on-off state

        // Define ones that are being called everywhere
        elements: {
            body: $("body"),
            iframes: $("body.single iframe"), // Be specific where the iframes might be added
            // iframePopUps: $('[inline-youtube], [inline-video], [inline-gmaps]'), // For all iframe popups
        },

        site_lang: $('html').attr('lang'), // get site language

        storage_names: {
            user_contact: "user-contact"
        },




    },
        /***********************************************************
        // COMPONENTS THAT ARE USED ON MORE THAN ONE PAGE & CALLABLE
        ***********************************************************/
        components = {


            // Bootsrap - Create modal for use for confirmation or error
            bs_modal: {

                success: function (title = "", content = '', classname = '') {

                    // if(content == "" ) return false;

                    title = title != "" ? title : "Form successfully submitted!";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_success.modal');
                    // Re-use existing if available
                    if (modal.length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        let modal = $('\
                            <div id="bs_modal_success" class="modal fade show" tabindex="-1" aria-hidden="true">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-success">\
                                            <h5 class="modal-title "><strong id="m-title">'+ title + '</strong></h5>\
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\
                                        </div>' : '<div class="modal-header">\
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\
                                        </div>') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                        <!--<div class="modal-footer"> \
                                            <button type="button" class="btn btn-primary mx-auto" data-bs-dismiss="modal">Close</button> \
                                        </div>--> \
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');
                    }

                },
                failed: function (title = "", content = '', classname = '') {

                    if (content == "") return false;

                    title = title != "" ? title : "Failed";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_failed.modal');

                    // Re-use existing if available
                    if (modal.length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        let modal = $('\
                            <div id="bs_modal_failed" class="modal fade show" tabindex="-1" aria-hidden="true">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-danger">\
                                            <h5 class="modal-title text-white"><strong id="m-title">'+ title + '</strong></h5>\
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\
                                        </div>' : '<div class="modal-header">\
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\
                                        </div>') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                        <!--<div class="modal-footer"> \
                                            <button type="button" class="btn btn-primary mx-auto" data-bs-dismiss="modal">Close</button> \
                                        </div>-->\
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');
                    }

                },
                show: function (title = "", content = '', classname = '') {

                    if (content == "") return false;

                    title = title != "" ? title : "";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_show.modal');

                    // Re-use existing if available
                    if ($(modal).length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        let modal = $('\
                            <div id="bs_modal_show" class="modal fade show" tabindex="-1" aria-hidden="true">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-secondary">\
                                            <h5 class="modal-title text-white"><strong id="m-title">'+ title + '</strong></h5>\
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\
                                        </div>' : '<div class="modal-header">\
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\
                                        </div>') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                        <!--<div class="modal-footer"> \
                                            <button type="button" class="btn btn-primary mx-auto" data-bs-dismiss="modal">Close</button> \
                                        </div>--> \
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');

                    }

                },
                dialog: function (title = "", content = '', classname = '') { // NO close function

                    if (content == "") return false;

                    title = title != "" ? title : "";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_dialog.modal');

                    // Re-use existing if available
                    if (modal.length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        modal = $('\
                             <div id="bs_modal_dialog" class="modal fade show" tabindex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-secondary">\
                                            <h5 class="modal-title text-white"><strong id="m-title">'+ title + '</strong></h5>\
                                        </div>' : '') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');
                    }

                },

            },

            bs_tab: function() {
                
                // Ensure vertical content are visible on tab change whee
                // $("[aria-orientation='vertical'][role='tablist'] > [data-bs-target]").each(function(e){

                //     let parentContainer = $(this).parents( "section" );
                                
                //     $(this).on('click',function(){
                //         $(parentContainer)[0].scrollIntoView({ block: "start", behavior: 'smooth' });
                        
                //     });

                // });

                // Change interact for on click to hover
                $(".content-collapsible-content-group--type-v .nav[role='tablist'][aria-orientation='vertical'] .nav-link").on("mouseenter", function (e) {
                    $(this).trigger('click');
                    return false;
                });


            },


            swiperjs:function(){

                // @link https://swiperjs.com/swiper-api

                // Custom SwiperJS components
                $(".swiper[swiperjs-settings]").each(function(){                    

                    // Get JSON object from attribute
                    const swiperjs_settings = jQuery.parseJSON( $(this).attr("swiperjs-settings") ); 

                    if(typeof swiperjs_settings =='object'){

                        // Base swiper settings

                        swiperjs_settings.effect = swiperjs_settings.effect == undefined ? 'horizontal' : swiperjs_settings.effect;

                        swiperjs_settings.loop = swiperjs_settings.loop == undefined ? 'false' : swiperjs_settings.loop;
                        
                        swiperjs_settings.autoHeight = swiperjs_settings.autoHeight == undefined ? 'true' : swiperjs_settings.autoHeight;

                        swiperjs_settings.direction = swiperjs_settings.direction == undefined ? 'horizontal' : swiperjs_settings.direction;


                        if(  swiperjs_settings.effect == 'cards' || swiperjs_settings.slidesPerView == 'auto' ){
                            swiperjs_settings.centeredSlides = true;
                        }

                        // swiperjs_settings.centeredSlides = swiperjs_settings.centeredSlides == undefined ? true : swiperjs_settings.centeredSlides;
                        if( swiperjs_settings.slidesPerView != undefined || swiperjs_settings.slidesPerView != "" || swiperjs_settings.slidesPerView != 0  ){
                            swiperjs_settings.slidesPerView = swiperjs_settings.slidesPerView;
                            // swiperjs_settings.slidesPerGroup = swiperjs_settings.slidesPerView;
                        }

                        swiperjs_settings.speed = swiperjs_settings.speed == undefined ? 800 : swiperjs_settings.speed;

                       // Show pagination if enabled
                       if( swiperjs_settings.pagination != undefined && swiperjs_settings.pagination == true ){
                            $(this).find('.swiper-pagination').removeClass('hidden');
                       }

                        swiperjs_settings.pagination = swiperjs_settings.pagination != undefined && swiperjs_settings.pagination == true ? {
                            el: '.swiper-pagination',
                            clickable: true
                          } : swiperjs_settings.pagination;

                        swiperjs_settings.noSwiping = swiperjs_settings.noSwiping == undefined ? false : 
                        swiperjs_settings.noSwiping;

                       // Show pagination if enabled
                       if( swiperjs_settings.navigation != undefined && swiperjs_settings.navigation == true ){
                            $(this).find('.swiper-nav').removeClass('hidden');
                       }

                        swiperjs_settings.navigation = swiperjs_settings.navigation != undefined && swiperjs_settings.navigation == true ? {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                          } : swiperjs_settings.navigation;

                        new Swiper($(this).get(0), swiperjs_settings);

                        // DEBUG
                        // if(global.debug_mode){
                        //     console.log(swiperjs_settings);
                        // }
                        
                        
                    }


                });

                // Default SwiperJS components
                // $(".swiper:not([swiperjs-settings])").each(function(){
                //     new Swiper('.swiper', {
                //         speed: 400,
                //         slidesPerView: 1,
                //         spaceBetween: 30,
                //         navigation: {
                //             nextEl: ".swiper-button-next",
                //             prevEl: ".swiper-button-prev",
                //           },
                //           pagination: {
                //             el: ".swiper-pagination",
                //             clickable: true,
                //           },
                //         // Responsive breakpoints
                //         breakpoints: {
                //           // when window width is >= 480px
                //           576: {
                //             slidesPerView: 3,
                //             // spaceBetween: 30
                //           },
                //           // when window width is >= 640px
                //           992: {
                //             slidesPerView: 4,
                //             // spaceBetween: 40
                //           }
                //         }
                //       });
                // });


            },

            fancybox: function(){
                /***********************************************************
                 // FANCYBOX - DEFAULT
                ***********************************************************/
                Fancybox.bind("[data-fancybox]", {
                    Html : {
                        youtube: {
                            controls: 1,
                            showinfo: 0,
                            autoplay:1,
                            playsinline: 1,
                            enablejsapi: 1
                        },
                    },
                    
                    vimeo: {
                        color: "f00",
                    },
                    on: {
                        done: (fancybox, slide) => {
                            if (
                            (slide.type == "iframe" && slide.src.includes("brightcove")) ||
                            slide.type == "video"
                            ) {
                            // console.log(slide);

                            // videoElementTrigger = $('a[href="' + slide.src + '"][data-fancybox]').eq(1);
                            videoTitle = slide.$trigger.dataset.title;
                            videoTitle =
                                videoTitle != undefined && videoTitle == null && videoTitle != ""
                                ? videoTitle
                                : slide.title;
                            video_link = slide.$trigger.dataset.href;
                            video_src = slide.$trigger.href;

                            videoDataObj = {
                                video_title: videoTitle,
                                video_link: video_link,
                                video_src: video_src,
                            };

                            // console.log( videoDataObj );

                            // GTM
                            components.gtm.dataLayerGAEventTracking(
                                "Video",
                                "Popup",
                                Object.keys(videoDataObj)
                                .map(function (k) {
                                    if (videoDataObj[k] != null || videoDataObj[k] != "") {
                                    return videoDataObj[k];
                                    }
                                })
                                .join(" - ")
                            );

                            // Google Analytics 4
                            // if (typeof window.gtag !== "undefined") {
                            // gtag('event', 'video_popup', {
                            //   'video_title': videoTitle,
                            //   'video_link': video_link,
                            //   'video_src': video_src,
                            // });
                            // }
                            }
                        },
                    },
                });

                /***********************************************************
                // FANCYBOX - Wordpress Gallery [Guttenberg]
                ***********************************************************/
                (function () {
                if ($(".gallery")) {
                    gallery = [];

                    $(".gallery").each(function (galleryIndex, gEl) {
                    $(gEl)
                        .find(".gallery-item")
                        .each(function (gallerySlideIndex) {
                        // Collect images into FancyBox array
                        $(this).each(function (index, galleryItem) {
                            var anchor = $(this).find("a");

                            if ($(anchor).length > 0) {
                            var thumb = $(anchor).find("img").attr("src");

                            var caption = $(this).find("figcaption").text();

                            gallery.push({
                                thumb: thumb,
                                src: $(anchor).get(0).href,
                                caption: caption,
                            });

                            // Click Event
                            $(anchor).on("click", function () {
                                Fancybox.show(gallery, { loop: false, startIndex: gallerySlideIndex });
                                return false;
                            });
                            }
                        });
                        });
                    });
                }
                })();

            },

            

            //Cookie Policy
            privacy_consent: function () {
                // Generator: https://cookieconsent.insites.com
                // Doc: https://www.osano.com/cookieconsent/documentation/about-cookie-consent/
                jQuery(function () {

                    // Ensure CookieConsent JS Plugin exists
                    if (typeof window.cookieconsent !== "undefined") {

                        // Multisite    
                        switch (global.site_lang) {
                            // case "fr-FR": // French
                            //    var privacy_content = {
                            //         "message": "Ce site Internet utilise des cookies pour améliorer et personnaliser votre expérience. Pour plus d’informations sur la collecte et l’utilisation de vos informations, y compris l’utilisation de cookies, merci de consulter notre ",
                            //         "link": "politique de confidentialité",
                            //         "dismiss": "Ok",
                            //         "href": "/fr-fr/politique-de-confidentialite",
                            //         "target": "_blank",
                            //    };
                            // 	break;

                            default: // Defaults to English
                                var privacy_content = {
                                    "message": "This website uses cookies to ensure you get the best experience on our website. Please check out our ",
                                    "link": "privacy policy",
                                    "dismiss": "ACCEPT COOKIES",
                                    "href": "/privacy",
                                    "target": "_blank",
                                };
                        };

                        window.cookieconsent.initialise({
                            //dismissOnTimeout: 10,
                            position: "bottom-right",
                            palette: {
                                "popup": {
                                    //"text": "#fff",
                                    "background": "rgba(102, 201, 186, 1)"
                                }
                            },
                            elements: {
                                //header: '<span class="cc-header">{{header}}</span>&nbsp;',
                                //"message": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}}.</p></div>",
                                "messagelink": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}} <a aria-label='learn more about cookies' tabindex='0' class='cc-link' href='{{href}}' target='_blank'>{{link}}</a>.</p></div>",
                                "dismiss": "<a aria-label='dismiss cookie message' tabindex='0' class='buttonDefault cc-btn cc-dismiss small'>{{dismiss}}</a>"
                            },
                            content: privacy_content,
                        });

                    }

                });
            },

            // Sticky Header
            stickyHeader: function (elements) {


                var root_margin = 0;


                // Sticky Target
                var sticky_target = $("#sticky-header-target");


                var headerHeight = $("header").length > 0 ? parseInt($("header").css("height")) : 0;

                // Target y position within the browser (24px is faux offset).
                // var root_margin = sticky_target.offset().top + 24;

                // Sticky menu
                root_margin = root_margin + (headerHeight);

                // alert(scroll_top);

                // Wordpress Adminbar (Only on desktop, ignored on mobile)
                if ($("#wpadminbar").length > 0) {
                    root_margin = root_margin + ($("#wpadminbar").css("postiion") == "fixed" ? parseInt($("#wpadminbar").css("height")) : 0);
                }

                // console.log(root_margin);

                var elements = $(elements).length != 0 ? $(elements) : $("header.fixed-top");

                if ($(elements).length > 0 && $(sticky_target).length > 0) {

                    var observer = new IntersectionObserver(function (entries) {
                        // no intersection with screen
                        if (entries[0].intersectionRatio === 0) {

                            $(elements).each(function () {
                                $(this).addClass('scrolled');
                                // $(this)[0].classList.add("scrolled");
                                // console.log("ADD... " + $(this).attr('class'));
                            });


                            if (global.debug_mode) {
                                // console.log("Sticky Target: Outside");
                            }
                        }
                        // fully intersects with screen
                        else if (entries[0].intersectionRatio === 1) {

                            $(elements).each(function () {
                                $(this).removeClass('scrolled');
                                // $(this)[0].classList.remove("scrolled");
                                // console.log("REMOVE... " +$(this).attr('class'));
                            });

                            if (global.debug_mode) {
                                // console.log("Sticky Target: Inside");
                            }
                        }

                    }, { rootMargin: root_margin + 'px', threshold: [0, 1] });

                    observer.observe($(sticky_target)[0]);
                }

            },
            // HandleBars
            handlebars: {

                // Use for tracking initialisation state
                init: false,

                // Use for storing cached template that has been compiled
                cached_template: {},

                // Render Template
                render: function (templateElement) {

                    // console.log("handlebars.render");

                    // Initialise helper if haven't 
                    if (this.init === false) this.extend();

                    if (templateElement === "" || templateElement === null) {
                        return false;
                    }

                    // Get ID and used for cached
                    var templateName = $(templateElement).attr("ID");

                    // console.log("Template Name: "+templateName);
                    // console.log(this.cached_template[templateName]);

                    if (this.cached_template[templateName] != undefined) {

                        // console.log("CACHED TEMPLATE");
                        return this.cached_template[templateName];

                    } else {

                        var templateSource = $(templateElement).html();

                        if (templateSource !== "" || templateSource !== null) {

                            // Compile handlebars and return
                            this.cached_template[templateName] = Handlebars.compile(templateSource);
                            return this.cached_template[templateName];
                        }
                    }

                    return false;
                },

                // Extend such as additional kelpers
                extend: function () {

                    // debug helper
                    // usage: {{debug}} or {{debug someValue}}
                    // from: @commondream (http://thinkvitamin.com/code/handlebars-js-part-3-tips-and-tricks/)
                    Handlebars.registerHelper("debug", function (optionalValue) {
                        console.log("Current Context");
                        console.log("====================");
                        console.log(this);

                        if (optionalValue) {
                            console.log("Value");
                            console.log("====================");
                            console.log(optionalValue);
                        }
                    });

                    Handlebars.registerHelper('reverse', function (arr) {

                        //console.log(typeof(arr))
                        if (global.polyfill_isArray(arr)) {
                            arr.reverse();
                        } else {
                            arr;
                        }

                    });

                    Handlebars.registerHelper('str_concatnate', function (a, b, opts) {
                        var str_combined = a + '' + b;
                        return new Handlebars.SafeString(str_combined);
                    });

                    Handlebars.registerHelper('str_replace', function (a, b, c, opts) {
                        var str_replaced = a.replace(b, c);
                        return new Handlebars.SafeString(str_replaced);
                    });

                    // Provides conditional string checks
                    Handlebars.registerHelper('if_eq', function (a, b, opts) {
                        if (a === b) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if string contains
                    Handlebars.registerHelper('if_contains', function (a, b, opts) {
                        if (a.indexOf(b) >= 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if obj contains
                    Handlebars.registerHelper('if_obj_contains', function (a, b, c, opts) {

                        var obj_founds = global.search_object_by_key(a, b, c);

                        if (obj_founds.length > 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if it's an object
                    Handlebars.registerHelper('is_obj', function (item, options) {
                        if (typeof item === "object") {
                            return options.fn(this);
                        } else {
                            return options.inverse(this);
                        }
                    });

                    // Comparsion Check
                    Handlebars.registerHelper('if_compare', function (lvalue, operator, rvalue, opts) {

                        var operators, result;

                        if (arguments.length < 3) {
                            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
                        }

                        if (opts === undefined) {
                            opts = rvalue;
                            rvalue = operator;
                            operator = "===";
                        }

                        operators = {
                            '==': function (l, r) {
                                return l == r;
                            },
                            '===': function (l, r) {
                                return l === r;
                            },
                            '!=': function (l, r) {
                                return l != r;
                            },
                            '!==': function (l, r) {
                                return l !== r;
                            },
                            '<': function (l, r) {
                                return l < r;
                            },
                            '>': function (l, r) {
                                return l > r;
                            },
                            '<=': function (l, r) {
                                return l <= r;
                            },
                            '>=': function (l, r) {
                                return l >= r;
                            },
                            'typeof': function (l, r) {
                                return typeof l == r;
                            }
                        };

                        if (!operators[operator]) {
                            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
                        }

                        result = operators[operator](lvalue, rvalue);

                        if (result) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }

                    });

                    //  Format a date
                    //  @link https://github.com/phstc/jquery-dateFormat
                    Handlebars.registerHelper('DateFormat', function (input, dateformat) {

                        // Normalize date to unix time
                        var unixTimestamp = new Date().getTime(input);
                        unixTimestamp = new Date(unixTimestamp).toISOString();

                        dateformat = dateformat == '' ? 'dd/MM/yyyy' : dateformat;

                        if (dateformat == 'pretty') {
                            return new Handlebars.SafeString($.format.prettyDate(new Date(unixTimestamp)));
                        } else {
                            return new Handlebars.SafeString($.format.date(new Date(unixTimestamp), dateformat));
                        }

                    });

                    // Finished initialisation
                    this.init = true;

                }


            },

            // In-line floating page menu
            pageSectionsMenu: {

                data: { 'items': [] }, // User for outut
                elements: 'main section .content-block-heading > h2',
                template: "script#x-template-page-sections-menu", // Handlebars JQuery selector
                handelbars: null, // For storing compiled Handlebars

                init: function () {
                    let _self = this;

                    // Content container
                    _self.elements = $(_self.elements);

                    // Return if empty
                    if ($(_self.elements).length == 0 || $(_self.template).length == 0 ) {
                        return null;
                    }



                    $(_self.elements).each(function () {


                        var section = $(this).parents('section[id]');

                        if ($(section).length == 1) {

                            var section_id = $(section).attr('id');
                            var section_heading = $(this).text();

                            _self.data.items.push({
                                'title': section_heading,
                                'url': '#' + section_id
                            });

                        }

                    });

                    if (_self.data.items.length > 0) {
                        _self.render_data(_self.data);
                    }


                },

                // Will render data using HandleBars
                render_data: function (data) {

                    const _self = this;

                    // Load Handlebars template
                    let HTMLTemplate = components.handlebars.render($(_self.template));

                    // Compile data into HTML using Handlebars
                    let outputHTML = HTMLTemplate(data);

                    // Add all the items
                    if ($('main section.header-block-simple').length > 0) {
                        $(outputHTML).insertAfter($('main section.header-block-simple'));
                    } else {
                        $(outputHTML).insertAfter($('main section').first());
                    }

                
                    let navSelectorString = '#' + $(outputHTML).attr('id') + ' a[href^="#"]' + ',' + '#dev-' + $(outputHTML).attr('id') + ' a[href^="#"]';
                    let navRenderedElements = $(navSelectorString);

                    let targetID = $('.page-sections-menu').first().attr('id');

                    // alert(targetID);

                    // Activate scrollspy
                    // $('body').scrollspy({ target: '.page-sections-menu' });
                    // const scrollSpy = new bootstrap.ScrollSpy(document.body, {
                    //     target: "#"+targetID
                    // })

                }

            },

            // GEO
            geo: {

                /**
                 * Get User geolocation 
                 */
                get_user_geolocation: function () {

                    // Try HTML5 geolocation.
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                const pos = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                };

                                return pos;
                            }
                        );
                    }

                    return false;

                },
            },

            // Google Tag Manager
            gtm: {

                /**
                 *  Google Tag Manager
                 */
                dataLayerGAEventTracking: function (category, action, label, value) {

                    window.dataLayer = window.dataLayer || [];

                    // Ensure GTM is load in initiated
                    if (typeof window.dataLayer !== 'undefined') {

                        window.dataLayer.push({
                            'event': 'ga_event',
                            'eventCategory': category,
                            'eventAction': action,
                            'eventLabel': label,
                            'eventValue': value
                        });

                    }


                },

            },

            forms: {

                // Default Bootstrap form validation
                init: function (forms) {

                    const _self = this;

                    // Fetch all the forms we want to apply custom Bootstrap validation styles to
                    forms = !!!forms && forms != undefined ? forms : $('form.needs-validation');

                    $(forms).each(function () {

                        const _form = this;

                        // MaxLength 
                        // @link https://github.com/mimo84/bootstrap-maxlength/
                        $(_form).find('textarea[maxlength]').maxlength({
                            appendToParent: true
                        });

                        $(_form).find('textarea').on('autosize:resized', function () {
                            $(_form).trigger('maxlength.reposition');
                        });

                        // Ensure legitimate value with spaces/line breaks not being validated
                        $(_form).find('textarea').on('change', function () {
                            var text = $(this).val().trim();
                            text = text.replace(/(?:(?:\r\n|\r|\n)\s*){2}/gm, "");
                            $(this).val(text);
                        });

                        // Replicate multiple select to addition input
                        $(_form).find('select[multiple]').each(function () {

                            let formElement = $(this);
                            let formElementID = $(formElement).attr('id');
                            let formElementName = $(formElement).attr('name');

                            let hiddenElement = $('<input />').attr('hidden', true).attr('type', 'hidden');
                            $(_form).append($(hiddenElement));

                            // 
                            if (formElementID != undefined) {
                                $(formElement).attr('id', "_" + formElementID);
                                $(hiddenElement).attr('id', formElementID);
                            }
                            if (formElementName != undefined) {
                                $(formElement).attr('name', "_" + formElementName);
                                $(hiddenElement).attr('name', formElementName);
                            }

                            $(formElement).on('change', function () {
                                var selectedValues = $(formElement).find('option:selected').map(function (i, opt) {
                                    return $(opt).text();
                                }).toArray().join(', ');
                                $(hiddenElement).val(selectedValues);
                            });

                        });

                        // Form branching
                        _self.formBranching.init(_form);

                        // Initialised to adjust form changes
                        // _self.reset(_form);

                        // Reset button
                        $(_form).on("reset", function (event) {
                            _self.reset(_form);
                        });


                        $(_form).on("submit", function (event) {

                            // Basic form check 
                            if ($(_form).get(0).checkValidity() === false) {

                                event.preventDefault();
                                event.stopPropagation();

                                $(_form).addClass('was-validated');

                                // Scroll to first error
                                var errorElements = $(this).find(".form-control:invalid");

                                if ($(errorElements).length > 0) {
                                    $(errorElements)[0].scrollIntoView({ block: "center", behavior: 'smooth' });
                                    $(_form).addClass('was-validated');
                                    return false;
                                }

                            }

                            // Disable submit button
                            components.forms.disableFormFields(_form, true);

                            // Google Recaptcha check if exists
                            if (global.google_recaptcha != undefined && global.google_recaptcha != '') {


                                if (global.google_recaptcha_token == null || global.google_recaptcha_token == undefined) {

                                    // Prevent form from submitting
                                    event.preventDefault();
                                    event.stopPropagation();

                                    // When Google Recaptcha token is ready, call ajax function
                                    $.when(

                                        // Get Google Recaptcha Token
                                        components.forms.getGoogleRecaptchaToken(_form),

                                    ).done(

                                        function (token) {

                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_google_recaptcha,
                                                    method: "POST",
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Ajax error or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {

                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);
                                                        if (global.wp_nonce != undefined && global.wp_nonce != "") {
                                                            xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                        }

                                                    },

                                                })


                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Re-enable submit button and text 
                                                    // $(submitBtn).each(function(){
                                                    //     $(this).removeAttr('disabled');
                                                    // });

                                                    if (response == true) {

                                                        // Request new Google Recaptcha token every 1.5 minutes as the token is valid upto 2 mins
                                                        setTimeout(() => {
                                                            global.google_recaptcha_token = null;
                                                        }, 90000);

                                                        // This form is ready for submission
                                                        $(_form).trigger('submit');

                                                        // if (global.debug_mode) {
                                                        //     const now = new Date();
                                                        //     const hours = now.getHours();
                                                        //     const minutes = now.getMinutes();
                                                        //     const seconds = now.getSeconds();
                                                        //     console.log(`${hours}:${minutes}:${seconds} - gRecaptcha token log: ${global.google_recaptcha_token}`);
                                                        // }

                                                        return true;

                                                    } else {


                                                        // This form is failed for submission
                                                        global.google_recaptcha_token = null;

                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Oops, something went wrong!', '<p>Our spam filter has detected abnomalities with your form submission.</p><p>Please <a href="#" onclick="location.reload(true); return false;">try again</a> or contact us should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;


                                                    }

                                                }
                                            );

                                        }

                                    );

                                }

                            }

                        });

                    });

                    if ($(forms).filter('form[contact]').length > 0) {
                        components.forms.contact.init();
                    }

                },

                reset: function (_form) {
                    $(_form).find('input,textarea,select').each(function () {

                        if ($(this).prop('nodeName') != undefined) {

                            if ($(this).prop('nodeName').toLowerCase() == 'select') {
                                // alert( $(this).prev().prop('nodeName') );
                                $(this).find('option[value=""]').prop('selected', true);
                            }

                            $(this).trigger('change');
                        }

                    });
                },

                // Enable/Disable form branching elements
                formBranching: {

                    form: null,

                    init: function (_form) {

                        const _self = this;

                        _self.form = _form;

                        var elements = $(_self.form).find('input[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"],textarea[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"],select[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"],option[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"]');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prop('nodeName') != undefined) {

                                if ($(this).prop('nodeName').toLowerCase() == 'input') {

                                    $(this).on('change', function () {

                                        if ($.trim($(this).val()) != '') {
                                            // alert($(this).val());
                                        } else {

                                        }

                                    });

                                }

                                if ($(this).prop('nodeName').toLowerCase() == 'textarea') {

                                    $(this).on('change', function () {

                                        if ($.trim($(this).val()) != '') {
                                            // alert($(this).val());
                                        } else {

                                        }

                                    });

                                }


                            }

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                if ($(this).parent().attr('form-branching-initialised') == undefined) {

                                    $(this).parent().attr('form-branching-initialised', true);

                                    $(this).parent().on('change', function () {

                                        // Show
                                        _self.enableFieldGroups($(this).children("option:selected").attr('data-bs-target'));

                                        $(_form).removeClass('was-validated');
                                        $(_form).removeClass('form-spam-validated');

                                    });

                                }

                            }

                        });

                    },

                    // Show group and fields
                    enableFieldGroups: function (_target) {

                        const _self = this;
                        _target = $(_self.form).find(_target);

                        _self.disableFieldGroups(_target);

                        if ($(_target).length > 0) {
                            $(_target).removeAttr('hidden');
                            $(_target).prop('hidden', false);
                            _self.enableFields(_target);
                        }

                    },

                    // Hide group and fields
                    disableFieldGroups: function (_target) {
                        const _self = this;
                        _target = $(_self.form).find("[id^='form-fields-branching-']");

                        if ($(_target).length > 0) {
                            $(_target).attr('hidden');
                            $(_target).prop('hidden', true);
                            _self.disableFields(_target);
                        }

                    },

                    // Enable various form fields
                    enableFields: function (_target) {

                        const _self = this;

                        var elements = $(_target).find('input,textarea,select,option');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                $(this).parent().prop('disabled', false);
                            } else {
                                $(this).prop('disabled', false);
                            }

                        });

                    },

                    // Disable various form fields
                    disableFields: function (_target) {

                        const _self = this;

                        var elements = $(_target).find('input,textarea,select,option');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                $(this).parent().prop('disabled', true);
                            } else {
                                $(this).prop('disabled', true);
                            }

                        });

                    },

                },

                // Contact form
                contact: {

                    elements: $("form[contact]"), // Jquery selector

                    // Initialisation
                    init: function (element) {

                        const _self = this;

                        var forms = _self.elements;
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-populate form fields 
                        _self.updateFormFields();

                        // Reinitialise form Conditions
                        $(forms).each(function(){

                            _form = $(this);

                            $(_form).on('reset', function(e){
                                _self.reinitialiseSelection(_form);
                                $(_form).get(0).reset();
                            });


                            $(_form).get(0).reset();

                            _self.reinitialiseSelection(_form);

                        });
                        

                    },

                    // Re-initialise contact type
                    reinitialiseSelection: function (form){
                        // Trigger preselect option to ensure conditional fields shown
                        var cfOptions = $(form).find('select option:selected');
                        if( $(cfOptions).length > 0 ){
                            var selectedIndex = $(cfOptions).parent().get(0).selectedIndex;
                            $(cfOptions).parent().get(0).selectedIndex = 0; // Reset
                            $(cfOptions).parent().get(0).selectedIndex = selectedIndex; // Re-select option
                            $(cfOptions).trigger('change');
                        }
                    },

                    // Updates form fields (input fields) with the data stored in browser
                    updateFormFields: function (data) {

                        const _self = this;
                        var forms = _self.elements;
                        if (forms === null) return;

                        var data = data != null && data != "" ? data : get_storage(global.storage_names.user_contact);

                        if (data != null && data != "") {

                            $.each(data, function (key, value) {

                                var formFields = $(forms).find("[name='" + key + "']");

                                if ($(formFields).length > 0) {

                                    $(formFields).val(value);
                                }
                            });

                            return true;

                        } else {
                            return false;
                        }


                    },

                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = _self.elements;
                        if (forms === null) return;

                        $(forms).each(function (index, _form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                $.when(

                                    $.ajax({
                                        url: global.ajax_endpoints.post_contact_form,
                                        method: "POST",
                                        dataType: "json",
                                        data: $(_form).serialize() + '&refURL=' + encodeURIComponent(window.location.href),
                                        statusCode: {
                                            404: function () {
                                                if (global.debug_mode) {
                                                    console.log("Request method not found");
                                                }
                                            },
                                            406: function () {
                                                if (global.debug_mode) {
                                                    console.log("Some data missing from the form");
                                                }
                                            },
                                            503: function () {
                                                console.log("Email did not send or other server related error while processing the request");
                                            }
                                        },
                                        beforeSend: function (xhr) {
                                            // Disable submit button
                                            components.forms.disableFormFields(_form, true);
                                        },
                                        complete: function () {
                                            // Enable submit button
                                            components.forms.disableFormFields(_form, false);
                                        },

                                    })

                                ).then(

                                    function (response, textStatus, jqXHR) {

                                        // Success
                                        if (response.success !== undefined && !!response.success) {

                                            // Store user form data and allow reuse for other contacts
                                            if (!!response.user) {
                                                set_storage(global.storage_names.user_contact, {
                                                    'first_name': response.user.first_name,
                                                    'last_name': response.user.last_name,
                                                    'phone': response.user.phone,
                                                    'email': response.user.email,
                                                });
                                            }

                                            // DEBUG RELATED
                                            if (global.debug_mode) {
                                                console.log(response);
                                            }



                                            // Re-enable form fields 
                                            components.forms.disableFormFields(_form, false);

                                            // components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Contact Form - ' + response.user.contact_type);

                                            var selectedContactOption = $(_form).find('select[name="contact_type"] option:selected');

                                            if ($(selectedContactOption).length > 0) {

                                                var gtag_contact_form_event_params_label = $(selectedContactOption).text();

                                                var selectedServiceProjectTypeOption = $(_form).find('select[name="service_project_type"] option:selected');

                                                // Append App Development (Eg. $10–20K) based on selection
                                                gtag_contact_form_event_params_label += $(selectedServiceProjectTypeOption).length > 0 ? ' & ' + $(selectedServiceProjectTypeOption).text() : '';

                                                var selectedServiceProjectBudgetOption = $(_form).find('select[name="service_budget"] option:selected');

                                                // Append Project Budget (Eg. $10–20K) based on selection
                                                gtag_contact_form_event_params_label += $(selectedServiceProjectBudgetOption).length > 0 ? ' & Budget: ' + $(selectedServiceProjectBudgetOption).text() : '';

                                                gtag_contact_form_event_params = {
                                                    'event_category': 'contact_form',
                                                    'event_label': gtag_contact_form_event_params_label,
                                                };

                                                // Push Google Analytics 4 event
                                                gtag('event', 'form_submit', gtag_contact_form_event_params);
                                            }


                                            // Google Ads - Event Snippet Conversion page
                                            // gtag('event', 'conversion', { 'send_to': 'AW-983288150/bZNOCOr93AgQ1pLv1AM' });


                                            components.bs_modal.success('Thank you for contacting us!', '<p>Thank you for contacting us ' + response.user.first_name + '. We will be in touch shortly.</p>');

                                            $(_form)[0].reset();


                                            return false;

                                        }


                                        if (global.debug_mode) {
                                            console.log(response);
                                        }


                                        // Show error if the response was unsuccessful
                                        components.bs_modal.failed('We\'re unable to submit the form', '<p>There was some issue trying to submit the form. Please try again later or kindly call us should the issue persist.</p><p>We apologise for the inconvenience caused.</p>');

                                        return false;


                                    }

                                );

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },

                // Enable or disable submit button, use during ajax 
                disableFormFields: function (_form, disabled = true, label = 'Please wait...') {

                    const _self = this;
                    if (_form == null || _form == undefined || _form.length == 0) return;

                    $(_form).find("[type='submit']").each(function () {

                        // Show/hide spinner and button text
                        if (true == disabled) {

                            // Add attribute when form is being processed
                            $(_form).attr('form-processing', true);

                            $(this).prop('disabled', true);

                            // Enable spinner and button status
                            $(this).find('[role="status"]').text(label);
                            $(this).find('[class*="spinner-"]').removeClass("hidden");

                        } else {

                            // Remove attr when form is being processed
                            $(_form).removeAttr('form-processing');

                            // Re-enabled form submit
                            $(this).prop("disabled", false);

                            $(_form).removeClass('was-validated');
                            $(_form).removeClass('form-spam-validated');

                            // Disable spinner and button status
                            $(this).find('[role="status"]').text($(this).attr('aria-label'));
                            $(this).find('[class*="spinner-"]').addClass("hidden");

                        }

                    });



                },

                // Get Google Recaptcha token form
                getGoogleRecaptchaToken: function (_form) {

                    // Ensure the function is executed before proceeding
                    return new Promise((res, rej) => {
                        grecaptcha.ready(function () {

                            global.g_action_name = $(_form).attr('name');
                            global.g_action_name = global.g_action_name == '' ? 'submit' : global.g_action_name;

                            grecaptcha.execute(global.google_recaptcha, { action: global.g_action_name }).then(function (token) {
                                // Set global recaptcha token
                                global.google_recaptcha_token = token;
                                return res(token);
                            });

                        })

                    })



                },

            },

            site_notifications: function (elements) {

                var elements = $(elements).length != 0 ? $(elements) : $("[data-notifications-id]");

                if ($(elements).length > 0) {

                    $(elements).each(function () {

                        var el = $(this);

                        // $(el).alert();

                        // var closeBtn = $(el).find('[data-dismiss]');
                        var is_preview = $(el).attr('is-preview');
                        is_preview = is_preview == undefined ? false : true;
                        var notificationID = get_storage($(el).data('notifications-id'), false);

                        if (is_preview == true) {
                            $(el).removeClass('hide').addClass('show');
                        } else {
                            if (notificationID != "true") {
                                $(el).removeClass('hide').delay(600).addClass('show');
                            } else {
                                $(el).addClass('hide');;
                            }
                        }

                        // Close button
                        $(el).on('closed.bs.alert', function () {

                            // Session storage where notication will be hidden
                            if (is_preview == true) {
                                alert('Note: You closed a preview notification.');
                            } else {
                                set_storage($(el).data('notifications-id'), 'true', false);
                            }

                        });

                    });


                }

            },

            // Ajax posts loading
            // HTML Element with "ajax-load-posts" attributes and WP_Query parameters
            ajaxGetPosts: {
                triggers: $("[ajax-load-posts]"), // Buttons that will initiate the ajax call
                handlebars: $("script#x-template-posts-listings"), // handlebars script. Will be compiled during init
                post_count: {}, // Number of posts loaded
                posts_container: {},

                // Initialising
                init: function () {

                    const _self = this;

                    if ($(_self.triggers).length == 0 || $(_self.handlebars).length == 0) {
                        return;
                    }

                    // Pre-compile handlebars
                    _self.handlebars = components.handlebars.render(_self.handlebars);
                    if (typeof (_self.handlebars) != 'function') {
                        // DEBUG RELATED
                        if (global.debug_mode) {
                            alert("Handlebars cannot compile into a function");
                        }
                        return;
                    }

                    $(_self.triggers).each(function (i, el) {

                        var posts_container = $(el).data('posts-container');
                        
                        _self.posts_container[i] = posts_container == '' || posts_container == undefined ? 'section' : posts_container;
                        // console.log(_self.posts_container[i]);
                        // console.log($(el).attr('ajax-load-posts'));
                        

                        // Set the number of posts already loaded
                        _self.post_count[i] = $( _self.posts_container[i] + ' article').length;
                        // console.log(_self.post_count[i]);

                        // Ajax requests and various DOM manipulations
                        $(el).on("click", function () {
                            // $(el).addClass('loading disabled');
                            // $(el).attr('disabled', true);
                            // alert(_self.posts_container[i]);
                            // return;
                            _self.load($(el), i);
                        });

                    });


                },

                // Load posts and various DOM manipulations
                load: function (_element, _index) {

                    const _self = this;

                    // Get params from HTML attribute and convert to JSON object
                    var ajax_params = JSON.parse($(_element).attr('ajax-load-posts'));

                    // console.log(ajax_params);

                    if (typeof (ajax_params) != 'object') {

                        // DEBUG RELATED
                        if (global.debug_mode) {
                            alert("Aborted Cannot find the last article.");
                        }

                        return;

                    }

                    // last article
                    let lastArticle = $(_self.posts_container[_index] + ' article:last');

                    // Ensure last article exists as required for use a parameter for post exclusion
                    if ($(lastArticle).length <= 0) {

                        // DEBUG RELATED
                        if (global.debug_mode) {
                            alert("Aborted Cannot find the last article.");
                        }

                        return;

                    }



                    // Additional ajax parameters from the last article
                    ajax_params['offset'] = _self.post_count[_index];

                    // Enable spinner and button status
                    $(_element).find('[role="status"]').text("Please wait");
                    $(_element).find('[class*="spinner-"]').removeClass("hidden");

                    let xhr = $.ajax({

                        url: global.ajax_endpoints.get_posts,
                        method: "GET",
                        // dataType : "json",
                        data: ajax_params,
                        statusCode: {
                            404: function () {
                                console.log("Error requesting posts data");
                            }
                        },
                        beforeSend: function () {
                            // Add attribute when form is being processed
                            $(_element).attr('ajax-processing', true);
                            $(_element).attr("disabled", true);
                        }, // Disable all buttons
                        complete: function () {
                            // Remove attr when form is being processed
                            $(_element).removeAttr('ajax-processing');
                            $(_element).attr("disabled", false);
                        }, // Enable all  buttons

                    });

                    $.when(xhr).done(function (response) {

                        if (response != "") {

                            if (response.post_count > 0) {

                                // Load Handlebars template
                                let HTMLTemplate = _self.handlebars;

                                // Compile data into HTML using Handlebars
                                let outputHTML = HTMLTemplate(response);
                                if (typeof (outputHTML) != 'string') {
                                    // DEBUG RELATED
                                    if (global.debug_mode) {
                                        alert("Aborted Handlebars cannot render HTML with the response data");
                                    }

                                    return;
                                }

                                // Parse string to DOM element
                                outputHTML = $.parseHTML(outputHTML);
                                $(outputHTML).insertAfter($(lastArticle));

                            }

                            // Disable spinner and button status
                            $(_element).find('[role="status"]').text($(_element).attr('aria-label'));
                            $(_element).find('[class*="spinner-"]').addClass("hidden");

                            // Increment post_count to keep track of loaded posts
                            _self.post_count[_index] = _self.post_count[_index] + response.post_count;

                            // If posts is less than the number of max posts per page, 
                            // destroy button is it's not longer needed
                            if (response.post_count >= response.found_posts || response.post_count < ajax_params['posts_per_page']) {
                                $(_element).parentsUntil('.row').addClass('hidden');
                                // alert(_self.post_count[_index] );
                                // console.log(_self.post_count);
                            }

                            // Debug number of posts loaded after ajax
                            // alert(_self.post_count[_index] );
                            // console.log(_self.post_count);
                            //console.log( $('article[data-timestamp]').length );

                        }

                        // DEBUG RELATED
                        if (global.debug_mode) {
                            console.log(response);
                        }

                        return;

                    });

                }
            },

            // Ajax posts loading
            // HTML Element with "ajax-load-posts" attributes and WP_Query parameters
            ajaxGetStaff: {
                triggers: $("[ajax-load-posts]"), // Buttons that will initiate the ajax call
                handlebars: $("script#x-template-appeals-listings"), // handlebars script. Will be compiled during init
                post_count: {}, // Number of posts loaded
                posts_container: {},

                // Initialising
                init: function () {

                    const _self = this;

                    if ($(_self.triggers).length == 0 || $(_self.handlebars).length == 0) {
                        return;
                    }

                    // Pre-compile handlebars
                    _self.handlebars = components.handlebars.render(_self.handlebars);
                    if (typeof (_self.handlebars) != 'function') {
                        // DEBUG RELATED
                        if (global.debug_mode) {
                            alert("Handlebars cannot compile into a function");
                        }
                        return;
                    }

                    $(_self.triggers).each(function (i, el) {

                        var posts_container = $(el).data('posts-container');
                        
                        _self.posts_container[i] = posts_container == '' || posts_container == undefined ? 'section' : posts_container;
                        // console.log(_self.posts_container[i]);
                        // console.log($(el).attr('ajax-load-posts'));
                        

                        // Set the number of posts already loaded
                        _self.post_count[i] = $( _self.posts_container[i] + ' article').length;
                        // console.log(_self.post_count[i]);

                        // Ajax requests and various DOM manipulations
                        $(el).on("click", function () {
                            // alert(_self.posts_container[i]);
                            // return;
                            _self.load(this, i);
                        });

                    });


                },

                // Load posts and various DOM manipulations
                load: function (_element, _index) {

                    const _self = this;

                    // Get params from HTML attribute and convert to JSON object
                    var ajax_params = JSON.parse($(_element).attr('ajax-load-posts'));

                    // console.log(ajax_params);

                    if (typeof (ajax_params) != 'object') {

                        // DEBUG RELATED
                        if (global.debug_mode) {
                            alert("Aborted Cannot find the last article.");
                        }

                        return;

                    }

                    // last article
                    let lastArticle = $(_self.posts_container[_index] + ' article:last');

                    // Ensure last article exists as required for use a parameter for post exclusion
                    if ($(lastArticle).length <= 0) {

                        // DEBUG RELATED
                        if (global.debug_mode) {
                            alert("Aborted Cannot find the last article.");
                        }

                        return;

                    }



                    // Additional ajax parameters from the last article
                    ajax_params['offset'] = _self.post_count[_index];

                    // Enable spinner and button status
                    $(_element).find('[role="status"]').text("Please wait");
                    $(_element).find('[class*="spinner-"]').removeClass("hidden");

                    let xhr = $.ajax({

                        url: global.ajax_endpoints.get_posts,
                        method: "GET",
                        // dataType : "json",
                        data: ajax_params,
                        statusCode: {
                            404: function () {
                                console.log("Error requesting posts data");
                            }
                        },
                        beforeSend: function () {
                            // Add attribute when form is being processed
                            $(_element).attr('ajax-processing', true);
                            $(_element).attr("disabled", true);
                        }, // Disable all buttons
                        complete: function () {
                            // Remove attr when form is being processed
                            $(_element).removeAttr('ajax-processing');
                            $(_element).attr("disabled", false);
                        }, // Enable all  buttons

                    });

                    $.when(xhr).done(function (response) {

                        if (response != "") {

                            if (response.post_count > 0) {

                                // Load Handlebars template
                                let HTMLTemplate = _self.handlebars;

                                // Compile data into HTML using Handlebars
                                let outputHTML = HTMLTemplate(response);
                                if (typeof (outputHTML) != 'string') {
                                    // DEBUG RELATED
                                    if (global.debug_mode) {
                                        alert("Aborted Handlebars cannot render HTML with the response data");
                                    }

                                    return;
                                }

                                // Parse string to DOM element
                                outputHTML = $.parseHTML(outputHTML);
                                $(outputHTML).insertAfter($(lastArticle));

                            }

                            // Disable spinner and button status
                            $(_element).find('[role="status"]').text($(_element).attr('aria-label'));
                            $(_element).find('[class*="spinner-"]').addClass("hidden");

                            // Increment post_count to keep track of loaded posts
                            _self.post_count[_index] = _self.post_count[_index] + response.post_count;

                            // If posts is less than the number of max posts per page, 
                            // destroy button is it's not longer needed
                            if (response.post_count >= response.found_posts || response.post_count < ajax_params['posts_per_page']) {
                                $(_element).parentsUntil('.row').addClass('hidden');
                                // alert(_self.post_count[_index] );
                                // console.log(_self.post_count);
                            }

                            // Debug number of posts loaded after ajax
                            // alert(_self.post_count[_index] );
                            // console.log(_self.post_count);
                            //console.log( $('article[data-timestamp]').length );

                        }

                        // DEBUG RELATED
                        if (global.debug_mode) {
                            console.log(response);
                        }

                        return;

                    });

                }
            },
            

            megamenu: function(){
                //Changes instances of hover to mobile touch
                $('.hover').bind('touchstart touchend', function(e) {
                    e.preventDefault();
                    $(this).toggleClass('hoverfx');
                });

                //Creates variables menu and menulink
                var $menu = $('.navli'),
                $menulink = $('#menubtn');

                //Changes instances of hover to mobile touch
                $('.hover').bind('touchstart touchend', function(e) {
                    e.preventDefault();
                    $(this).toggleClass('hoverfx');
                });

                //Adds .parent to any anchor with an UL after it
                $(".navli li a").each(function () {
                    if ($(this).next().length > 0) {
                        $(this).addClass('parent');
                    }
                });

                //Adds .dropdn to any li with an UL after it
                $(".navli li").each(function () {
                    if ($(this).children('ul').length > 0) {
                        $(this).addClass('dropdn');
                    }
                });

                //Makes #menubtn clickable
                $menulink.click(function (e) {
                    e.preventDefault();
                    $menulink.toggleClass('collapsed');
                    $menulink.toggleClass('activ');
                    $menu.toggleClass('activ');
                    $('.nav-holder, header.fixed-top').toggleClass('active');
                });

                //Creates clickable .nav-more div
                $(function () {
                    $('<div class="nav-more">&nbsp;</div>').insertAfter('a.parent');
                });

                //Makes ul after an li clickable
                $(function () {
                    $('.nav-more').click(function (e) {
                        e.preventDefault();
                        $(this).toggleClass('activ');
                        $(this).next("ul").toggleClass('activ');
                        $(".navli li a").unbind('mouseenter mouseleave');
                        $(".navli li ul li").unbind('mouseenter mouseleave');
                    });
                });
            }

        },

        /***********************************************************
        // PAGE SPECIFIC FUNCTIONS
        ***********************************************************/
        pages = function () {

            if ($("body").hasClass('page')) {

            }
            
            if( !!( $('body').hasClass('page-home') || $('body').hasClass('page-search') ) ){

                var stickyTarget = $("<span sticky-target aria-hidden='true'></span>");
                $($("body")).prepend( stickyTarget );
    
                var headerElements = $(".page-heading,.page-header-image");
                if( $(headerElements).length > 0 ){
                    // var stickyTarget = $('header nav');
    
                    // var heightOffset = ( parseInt( $("header").css('height') ) * 0.6 );
                    var heightOffset = 100;
    
                    var observer = new IntersectionObserver(function(entries) {
            
                        // no intersection with screen
                        if(entries[0].intersectionRatio === 0) {
                            // $("header nav").addClass('fixed-top');
                            // $(headerElements).delay(200).slideUp(200);
                            $(headerElements).addClass("d-none");
                            console.log('out');
                        }
                        // fully intersects with screen
                        else{
                            // $("header nav").removeClass('fixed-top');
                            // $(headerElements).delay(200).slideDown(200);
                            $(headerElements).removeClass("d-none");
                            console.log('in');
                        }
                    
                    });
                    
                  observer.observe( $(stickyTarget).get(0) );
    
                }
    
            }

            // Single Course page
            if ($("body").hasClass('single-course')) {

                // Enable shortcut if course workshops exists
                if( $('.ax-course-instance-list td.instance_date').length > 0){
                    // $('.ax-course-instance-list').attr('id', 'ax-course-instance-container');
                    $('.booking-shortcuts').fadeOut().toggleClass('hidden').fadeIn();

                    $('.booking-shortcuts button').on('click', function(e){
                        e.preventDefault();
                        if($('.ax-course-instance-list').length > 0){
                            $('.ax-course-instance-list').parentsUntil('section')[0].scrollIntoView({ block: "center" });
                        }
                        
                    });

                }
                    
            }

            // Add Bootstap classes to table tags in .WYSIWYG
            $("body:not(.woocommerce-page) .wysiwyg table").wrap('<div class="table-responsive"></div>');
            $('.wysiwyg table').addClass('table');

            // Show all listing items that were otherwise hidden
            $("[data-show-all-listings]").on("click", function (e) {

                // Max number to show
                let max_items = $(this).data("max-items");

                max_items = max_items != null || max_items != "undefined" ? max_items : 10;
                e.preventDefault();

                if ( $(this).data("show-all-listings") != "" && $(this).data("listing-targets") != "" ) {

                    let listing_selector_str  = $(this).data("show-all-listings") + ' ' + $(this).data("listing-targets") + '.hidden';

                    // alert(listing_selector_str);

                    let targeted_hidden_items = $(listing_selector_str);

                    if ($(targeted_hidden_items).length > 0) {

                        // alert('ALL: ' + $(targeted_items).length );
                        // alert('HIDDEN: ' + $(targeted_hidden_items).length );

                        $(targeted_hidden_items).each(function (index) {

                            if( index <= ( max_items - 1)  ){
                                $(this).hide().removeClass("hidden").delay(200).fadeIn();
                            }

                        });

                        // GET all listing
                        targeted_hidden_items = $(listing_selector_str);

                        // Hide button
                        if ($(targeted_hidden_items).length <= 0) {
                            $(this).remove();
                        }

                    }
                }

                return false;
            });

            


            $( ".footer-links ul.menu>li:first-child" ).append( "<span></span>" );

            $(".footer-links ul.menu>li:first-child span").on("click", function (e) {
                $(this).closest("ul.menu").toggleClass("open");
            })

             
        },

        /***********************************************************
        // Other functions as required
        ***********************************************************/
        misc_func = function () { };


    /***********************************************************
    // Utility functions
    ***********************************************************/

    // Bootstrap breakpoint
    // @link https://unpkg.com/bootstrap-detect-breakpoint@1.0.8/src/bootstrap-detect-breakpoint.js
    bootstrapDetectBreakpoint = {

        init: function () {
            const _self = this;

            global.breakpoint.current = _self.detect();
            global.breakpoint.last = _self.detect();

            if (global.debug_mode) {
                console.log(global.breakpoint);
            }

            let resizeTimeout;

            window.addEventListener('resize', function () {
                clearTimeout(resizeTimeout);
                // Ensure the change has been settled before calling proceeding
                resizeTimeout = setTimeout(() => {
                    if (!!global.breakpoint) {

                        // set last changed value
                        global.breakpoint.last = global.breakpoint.current;

                        // set current changed value
                        global.breakpoint.current = _self.detect();

                        // Reload page if viewport changed between 'sm' <> 'md'
                        // if (global.breakpoint.last.index < global.breakpoint.current.index || global.breakpoint.last.index > global.breakpoint.current.index) {
                        //     console.log("before: " + currentBreakpoint.name + " | after: " + global.breakpoint.name);
                        // }

                        // if (global.debug_mode) {
                        //     console.log(global.breakpoint);
                        // }

                    }
                }, 50);

            });

        },
        //
        detect: function () {
            // cache some values on first call
            if (!this.breakpointValues) {
                this.breakpointNames = ["xl", "lg", "md", "sm", "xs"]
                this.breakpointValues = []
                for (const breakpointName of this.breakpointNames) {
                    this.breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-' + breakpointName)
                }
            }
            let i = this.breakpointNames.length
            for (const breakpointName of this.breakpointNames) {
                i--
                if (window.matchMedia("(min-width: " + this.breakpointValues[breakpointName] + ")").matches) {
                    return { name: breakpointName, index: i }
                }
            }
            return null
        },

    },

    // Utility method to get browser data
    get_storage = function (storageName, is_persistentStorage = true, expires = '') {

        if (storageName != "") {

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {

                // Not expiry
                var expires = '';

                // LocalStorage
                storageData = window.localStorage.getItem(storageName);

                if (expires != '') {
                    storageDataExpiry = window.sessionStorage.getItem('_' + storageName);
                }
                else {
                    storageDataExpiry = false;
                }


            } else {

                // 1 hour by default
                var expires = '';

                // SessionStorage
                storageData = window.sessionStorage.getItem(storageName);

                if (expires != '') {
                    storageDataExpiry = window.sessionStorage.getItem('_' + storageName);
                } else {
                    storageDataExpiry = false;
                }

            }

            // Check if expired
            if (storageDataExpiry !== false && (storageDataExpiry != '' || storageDataExpiry == 'undefined' || Date.now() > storageDataExpiry)) {
                delete_storage(storageName, is_persistentStorage);
            }

            if (storageData != null || storageData != "undefined") {

                // Always try to return as data as JS object if JSON or other data types
                try {
                    return JSON.parse(storageData);
                } catch (e) {
                    return storageData;
                }
            } else {
                return false;
            }

        }
        else {
            return false;
        }

    };

    // Utility method to store browser data and defaults to an hour
    set_storage = function (storageName, storageData, is_persistentStorage = true, expires = '') {


        if (storageName != "") {

            // Always assume data is for JSON and escape data were necessary
            var storageData = JSON.stringify(storageData);

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {

                // Not expiry
                var expires = '';

                // LocalStorage
                window.localStorage.setItem(storageName, storageData);

                if (expires != '') {
                    window.localStorage.setItem('_' + storageName, Date.now() + expires);
                }

            } else {

                // Default 1 hour by default
                // var expires = (60*60*1000);

                // SessionStorage
                window.sessionStorage.setItem(storageName, storageData);
                if (expires != '') {
                    window.sessionStorage.setItem('_' + storageName, Date.now() + expires);
                }
            }
            return true;
        }
        else {
            return false;
        }

    };

    // Utility method to store browser data
    delete_storage = function (storageName, is_persistentStorage = true) {


        if (storageName != "") {

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {
                // LocalStorage
                window.localStorage.removeItem(storageName);
                window.localStorage.removeItem(storageName + '_expires');

            } else {
                // SessionStorage
                window.sessionStorage.removeItem(storageName);
                window.sessionStorage.removeItem(storageName + '_expires');
            }



        }
        else {
            return false;
        }
    };


    // Update HTML Document Title
    updateDocumentTitle = function (pageTitle, currentDocumentTitle) {

        let documentTitleSeparator = "|";
        let regExp = new RegExp('[\'' + documentTitleSeparator + ']', "g");

        currentDocumentTitle = !!!currentDocumentTitle ? document.title : currentDocumentTitle;

        let separatorCount = (currentDocumentTitle.match(regExp) || []).length;

        if (separatorCount > 1) {
            currentDocumentTitle = currentDocumentTitle.substring(currentDocumentTitle.indexOf(documentTitleSeparator + " ") + 1);
        }

        return document.title = pageTitle + " " + documentTitleSeparator + " " + currentDocumentTitle.trim();

    };


    // Initialise JS Class and functions
    return {

        init: function () {

            // DEBUG RELATED
            if (global.debug_mode) {

                console.log("Debug Mode: " + global.debug_mode);

            }

            // Detect breakpoint/viewport
            bootstrapDetectBreakpoint.init();
            
            // Components Used throughout the site
            components.bs_tab();
            components.stickyHeader();
            //components.privacy_consent();
            // components.splashScreens.init();
            components.swiperjs();
            components.fancybox();
            //components.pageSectionsMenu.init(); // In-line page menu
            components.forms.init(); // Form validation and submission
            components.site_notifications(); // Site notifications
            components.ajaxGetPosts.init(); // Ajax post component
            // components.ajaxGetStaffs.init(); // Ajax post component
            // components.gsapAnimations();
            components.megamenu();

            // Page Specific functions
            pages();

        },
    };

}());

jQuery(function () {
    SparkDigital.init();
});




